var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2563_68218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.969244 8.07823L6.80295 13.9149C6.85778 13.9697 6.93183 14 7.00938 14C7.08692 14 7.161 13.9691 7.21581 13.9143L13.032 8.07823C13.1154 7.99483 13.1399 7.86947 13.095 7.76041C13.0495 7.65137 12.9434 7.58079 12.8256 7.58079L9.61836 7.58079L9.61836 0.291551C9.61836 0.130605 9.48773 -2.70202e-05 9.32678 -2.70342e-05L4.66166 -2.74421e-05C4.50071 -2.74562e-05 4.37008 0.130605 4.37008 0.291551L4.37008 7.58082L1.17507 7.58082C1.05729 7.58082 0.951148 7.65197 0.905663 7.76101C0.860179 7.87005 0.885846 7.99483 0.969244 8.07823Z",
    fill: "#233242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2563_68218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardArrowDown);
export default __webpack_public_path__ + "static/media/iconCardArrowDown.068427c1192e3d525591410c78638348.svg";
export { ForwardRef as ReactComponent };